import { render, staticRenderFns } from "./VerticalWorks.vue?vue&type=template&id=bedb1c72"
import script from "./VerticalWorks.vue?vue&type=script&lang=js"
export * from "./VerticalWorks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports